export default __webpack_public_path__ + "static/media/misc-books2-1920w.292cb134.webp";